<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="fw-500">
              {{ value.emoj }}
              <span class="text fw-600 pc">{{ value.userName }} </span>
            </h1>
          </div>
          <div class="col-sm-6 d-none">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">{{ $t("home") }}</router-link>
              </li>
              <li class="breadcrumb-item active">{{ $t("home_page") }}</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row" v-if="this.organizationId == 1">
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-device">
              <a @click="navigateTo('DeviceList')" href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-total-users"></use></svg>
                </div>
                <h3>
                  Total Users<span
                    >{{ value.total_users ? value.total_users : "0" }}
                  </span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-device">
              <router-link :to="{ name: 'ActivationKeyList' }" class="link-cell">
                <div class="dashboard-card-img">
                  <img src="/assets/images/total_activated.svg" alt="total_activated" />
                </div>
                <h3>
                  Active subscriptions<span>{{
                    value.total_audra_devices ? value.total_audra_devices : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-device">
              <router-link
                :to="
                  value.online_audra_devices > 0
                    ? {
                        name: 'RouterList',
                        params: {
                          searchtype: 'status',
                          searchparam: 'active',
                        },
                      }
                    : ''
                "
                :class="value.online_audra_devices > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-audra-online"></use></svg>
                </div>

                <h3>
                  Online devices
                  <span>{{
                    value.online_audra_devices ? value.online_audra_devices : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-device">
              <router-link
                :to="
                  value.offline_audra_devices > 0
                    ? {
                        name: 'RouterList',
                        params: {
                          searchtype: 'status',
                          searchparam: 'inactive',
                        },
                      }
                    : ''
                "
                :class="value.offline_audra_devices > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-audra-offine"></use></svg>
                </div>
                <h3>
                  Offline devices<span>{{
                    value.offline_audra_devices ? value.offline_audra_devices : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
        </div>

        <div class="form-row user-dashboard" v-if="this.organizationId != 1">
          <div class="col-6 col-md-4 col-xl-2">
            <div class="dashboard-card dashboard-card-device">
              <router-link
                :to="
                  value.total_audra > 0
                    ? {
                        name: 'ActivationKeyList',
                      }
                    : ''
                "
                :class="value.total_audra > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <img src="/assets/images/total_activated.svg" alt="total_activated" />
                </div>
                <h3>
                  Active subscriptions<span>{{
                    value.total_audra ? value.total_audra : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-6 col-md-4 col-xl-2">
            <div class="dashboard-card dashboard-card-device">
              <router-link
                :to="
                  value.online_audra > 0
                    ? {
                        name: 'RouterList',
                        params: {
                          searchtype: 'status',
                          searchparam: 'active',
                        },
                      }
                    : ''
                "
                :class="value.online_audra > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-audra-online"></use></svg>
                </div>

                <h3>
                  Online devices
                  <span>{{ value.online_audra ? value.online_audra : "0" }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-md-4 col-xl-2">
            <div class="dashboard-card dashboard-card-device">
              <router-link
                :to="
                  value.offline_audra > 0
                    ? {
                        name: 'RouterList',
                        params: {
                          searchtype: 'status',
                          searchparam: 'inactive',
                        },
                      }
                    : ''
                "
                :class="value.offline_audra > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-audra-offine"></use></svg>
                </div>
                <h3>
                  Offline devices
                  <span>{{ value.offline_audra ? value.offline_audra : "0" }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-md-4 col-xl-3">
            <div class="dashboard-card dashboard-card-device">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-total-device"></use></svg>
                </div>
                <h3>
                  Connected Client devices (last 7 days)
                  <span>{{
                    value.devices_connected_last_7_days
                      ? value.devices_connected_last_7_days
                      : "0"
                  }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-md-4 col-xl-3">
            <div class="dashboard-card dashboard-card-device">
              <!-- <a @click="navigateTo('DeviceList')" href="javascript:void(0)"> -->
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-device-connected"></use></svg>
                </div>
                <h3>
                  Connected Client devices (now)<span
                    >{{ value.devices_connected_now ? value.devices_connected_now : "0" }}
                  </span>
                </h3>
              </a>
            </div>
          </div>
        </div>
        <div class="form-row user-dashboard" v-if="this.organizationId != 1">
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-threats-prevented"></use></svg>
                </div>
                <h3>
                  Total threats prevented
                  <span>{{
                    value.threats_prevented ? value.threats_prevented : "0"
                  }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-adware"></use></svg>
                </div>
                <h3>
                  Adware <span>{{ value.adware ? value.adware : "0" }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-malware"></use></svg>
                </div>
                <h3>
                  Malware <span>{{ value.malware ? value.malware : "0" }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-5 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-ddos"></use></svg>
                </div>
                <h3>
                  DDOS <span>{{ value.ddos ? value.ddos : "0" }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-7 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-attempt-prevented"></use></svg>
                </div>
                <h3>
                  Violations
                  <span>{{
                    value.attempts_prevented ? value.attempts_prevented : "0"
                  }}</span>
                </h3>
              </a>
            </div>
          </div>
        </div>
        <h4 class="card-common-title p-0 py-3">
          <span class="text-capitalize fw-600 pc">{{
            value.device_name ? value.device_name : "Device"
          }}</span>
          Information
          <small class="text-muted d-block d-md-inline-block mt-1 mt-md-0"
            >(
            {{
              value.device_status
                ? "Uptime: " + formattedUptime
                : "Downtime: " + formattedDowntime
            }}
            {{ "& Usage Today: " }}
            {{
              value.usageToday
                ? value.usageToday / 1024 < 1024
                  ? (value.usageToday / 1024).toFixed(2) + " KB"
                  : value.usageToday / 1024 / 1024 < 1024
                  ? (value.usageToday / 1024 / 1024).toFixed(2) + " MB"
                  : value.usageToday / 1024 / 1024 / 1024 > 0
                  ? (value.usageToday / 1024 / 1024 / 1024).toFixed(2) + " GB"
                  : value.usageToday.toFixed(2) + " bytes"
                : "0 byte"
            }}

            )</small
          >
        </h4>
        <div class="card device-info">
          <div class="card-body">
            <ul>
              <li>
                <i class="icon-cpu"></i>
                <h3>
                  MAC:
                  <strong class="device_name">{{
                    value.apWiMac ? value.apWiMac : "MAC Address"
                  }}</strong>
                </h3>
              </li>
              <li>
                <i class="icon-tablet"></i>
                <h3>
                  Firmware version:
                  <strong>{{ value.version ? value.version : "0.0.0" }}</strong>
                </h3>
              </li>
              <li>
                <i class="icon-globe"></i>
                <h3>
                  Device status:
                  <strong v-if="!value.device_status" class="offline">Offline</strong>
                  <strong v-else class="online">Online</strong>
                </h3>
              </li>
              <li>
                <i class="icon-calendar"></i>
                <h3>
                  Subscription End:
                  <strong :class="{ offline: isSubscriptionExpired }">{{
                    formattedNextRenewDate
                      ? new Date(formattedNextRenewDate).toLocaleDateString(
                          "en-GB",
                          dateOptions
                        )
                      : "NA"
                  }}</strong>
                </h3>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-row user-dashboard">
          <div class="col-md-6">
            <div class="dashboard-card dashboard-card-device">
              <router-link :to="{ name: 'DeviceList' }" class="link-cell">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-device-connected"></use></svg>
                </div>
                <h3>
                  Connected Client devices (now)<span>{{
                    value.device_connected_now ? value.device_connected_now : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dashboard-card dashboard-card-device">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-total-device"></use></svg>
                </div>
                <h3>
                  Connected Client devices (last 7 days)
                  <span>{{
                    value.device_connected_last_7_days
                      ? value.device_connected_last_7_days
                      : "0"
                  }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-threats-prevented"></use></svg>
                </div>
                <h3>
                  Threats Prevented
                  <span>{{
                    value.device_threats_prevented ? value.device_threats_prevented : "0"
                  }}</span>
                </h3>
              </a>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <router-link
                :to="
                  value.device_adware > 0
                    ? {
                        name: 'OccuranceList',
                        query: { destination_hosts: '__Adware' },
                      }
                    : ''
                "
                :class="value.device_adware > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-adware"></use></svg>
                </div>
                <h3>
                  Adware
                  <span>{{ value.device_adware ? value.device_adware : "0" }}</span>
                </h3>
              </router-link>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <router-link
                :to="
                  value.device_malware > 0
                    ? {
                        name: 'OccuranceList',
                        query: { destination_hosts: '__Malware' },
                      }
                    : ''
                "
                :class="value.device_malware > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-malware"></use></svg>
                </div>
                <h3>
                  Malware
                  <span>{{ value.device_malware ? value.device_malware : "0" }}</span>
                </h3>
              </router-link>
            </div>
          </div>

          <div class="col-5 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <a href="javascript:void(0)">
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-ddos"></use></svg>
                </div>
                <h3>
                  DDOS
                  <span>{{ value.device_ddos ? value.device_ddos : "0" }}</span>
                </h3>
              </a>
            </div>
          </div>

          <div class="col-7 col-md-3">
            <div class="dashboard-card dashboard-card-violation">
              <router-link
                :to="
                  value.device_attempts_prevented > 0
                    ? {
                        name: 'OccuranceList',
                        query: { destination_hosts: '__All_Sites' },
                      }
                    : ''
                "
                :class="value.device_attempts_prevented > 0 ? 'link-cell' : ''"
              >
                <div class="dashboard-card-img">
                  <svg><use xlink:href="#icon-malware"></use></svg>
                </div>
                <h3>
                  Violations
                  <span>{{
                    value.device_attempts_prevented
                      ? value.device_attempts_prevented
                      : "0"
                  }}</span>
                </h3>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content mt-1">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <vue-highcharts
                  :options="routerUsageHighChartOptions"
                  ref="lineCharts"
                ></vue-highcharts>
              </div>
              <div class="col-md-6">
                <vue-highcharts
                  :options="totalUsageSummaryHighChartOptions"
                  ref="totalUsageSummaryLineCharts"
                ></vue-highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header py-3 border-0" v-if="is_loading == false">
            <h2 class="card-common-title p-0 m-0">WAN Info</h2>
            <div class="wan-info-nav">
              <ul>
                <li
                  v-if="value.totalWan > 1"
                  :class="{
                    active: WANInfoType == 'Primary',
                  }"
                  @click="setWANInfo('primary')"
                >
                  Primary
                </li>
                <li
                  v-if="value.totalWan > 1"
                  :class="{
                    active: WANInfoType == 'Secondary',
                  }"
                  @click="setWANInfo('secondary')"
                >
                  Secondary
                </li>
                <div v-if="value.totalWan > 0" class="wan-indicator"></div>
              </ul>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div class="card-body pt-2 pb-4">
            <div v-if="is_loading == false">
              <div class="wan-info-list">
                <!-- <h3>{{ WANInfoType }}</h3> -->
                <ul>
                  <li>
                    <h5>
                      WAN Status
                      <span v-if="WANInfo.status == 1" class="online">Online</span>
                      <span v-else class="offline">Offline</span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Connection Type<span>
                        {{
                          WANInfo?.proto === "0"
                            ? "NA"
                            : WANInfo?.proto?.toUpperCase() || "NA"
                        }}
                      </span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      IP Address<span>{{ WANInfo.ip == "0" ? "NA" : WANInfo.ip }}</span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Subnet Mask<span>{{
                        WANInfo.subnetmask == "0" ? "NA" : WANInfo.subnetmask
                      }}</span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Default Gateway<span>{{
                        WANInfo.gateway == "0" ? "NA" : WANInfo.gateway
                      }}</span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      DNS<span>{{ WANInfo.dns == "0" ? "NA" : WANInfo.dns }}</span>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      MAC<span>{{ WANInfo.mac == "0" ? "NA" : WANInfo.mac }}</span>
                    </h5>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="content"
      v-if="
        1 == 0 && has_permission === true && value.adminuser != 1 && value.ruleId != 2
      "
    >
      <div class="container-fluid" v-if="1 == 0">
        <div class="row card-equal">
          <div class="col-md-6">
            <div class="card">
              <h4 class="card-common-title pb-2 pt-4">IPSEC Transport Status</h4>
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>

              <div class="card-body">
                <div
                  class="table-responsive-md"
                  v-if="!_.isEmpty(ipsecTransportStatusList.data) && is_loading == false"
                >
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="column-source_address">Audra</th>
                        <th class="column-source_address">Profile</th>
                        <th class="column-source_address">Gateway</th>
                        <th class="column-duration">Status</th>
                        <th class="column-frequency">Action</th>
                      </tr>
                    </thead>
                    <tbody class="routerStatusList">
                      <tr v-for="(val, index) in ipsecTransportStatusList.data">
                        <td>{{ val.device_name }}</td>
                        <td>{{ val.ipsec_profile_name }}</td>
                        <td>{{ val.vti_remote_ip }}</td>
                        <td>{{ statusLabel[index] }}</td>
                        <td
                          @click="changeIpSecTransportStatus(val, index)"
                          style="font-weight: bold; cursor: pointer"
                        >
                          {{ val.ipsec_is_active ? "Disconnect" : "Connect" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="p-2"
                  v-if="_.isEmpty(ipsecTransportStatusList.data) && is_loading == false"
                >
                  <div class="no-data">
                    <img src="/assets/images/no-data.svg" alt="" />
                    <h3>No data found!</h3>
                  </div>
                </div>
              </div>

              <div class="card-footer text-center pt-1 pb-4 audra-status">
                <div
                  v-if="!_.isEmpty(ipsecTransportStatusList.data) && is_loading == false"
                >
                  <router-link
                    v-if="this.organizationId == 1"
                    :to="{
                      name: 'IPSECTransportStatusList',
                    }"
                    class="btn"
                  >
                    View All
                  </router-link>
                </div>

                <!-- <vue-pagination
                  :pagination="ipsecTransportStatusList"
                  v-if="
                    ipsecTransportStatusList.total >
                    ipsecTransportStatusList.per_page
                  "
                  @paginate="reloadIpsecTransportStatus()"
                ></vue-pagination> -->
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <h4 class="card-common-title d-flex align-items-center">
                <span id="lstUpdate">{{ ospfNeighborLastUpdate }}</span>
                <a
                  @click="getOspfNeighbor()"
                  style="line-height: normal"
                  class="badge ml-auto py-2 px-3 fw-500"
                >
                  <i class="icon-refresh mr-2"></i> OSPF Neighbor
                </a>
              </h4>
              <div class="overlay" v-if="is_loading_ospf">
                <img src="/assets/images/loader.svg" alt="" />
              </div>

              <div class="card-body">
                <div
                  class="table-responsive-md"
                  v-if="!_.isEmpty(this.neighborList.data) && is_loading_two == false"
                >
                  <table class="table table-hover" id="grid-ospfNeighbor">
                    <thead>
                      <tr>
                        <th class="column-destination_address">Neighbor ID</th>
                        <th class="column-duration">Neighbor Address</th>
                        <th class="column-frequency">State</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(val, index) in displayedNeighbors">
                        <td>{{ val.key }}</td>
                        <td>{{ val.address }}</td>
                        <td>{{ val.state }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="p-2"
                  v-if="_.isEmpty(this.neighborList.data) && is_loading == false"
                >
                  <div class="no-data">
                    <img src="/assets/images/no-data.svg" alt="" />
                    <h3>No data found!</h3>
                  </div>
                </div>
              </div>

              <div
                class="card-footer text-center pt-1 pb-4 audra-status"
                v-if="!_.isEmpty(this.neighborList.data) && is_loading == false"
              >
                <button
                  class="pagination-btn prev d-none"
                  @click="setPage(neighborList.currentPage - 1)"
                  :disabled="neighborList.currentPage === 1"
                >
                  &lt;
                </button>
                <div class="pagination-pages d-none">
                  <span
                    v-for="page in totalPages"
                    :key="page"
                    class="pagination-page"
                    :class="{ active: page === neighborList.currentPage }"
                    @click="setPage(page)"
                  >
                    {{ page }}
                  </span>
                </div>
                <button
                  class="pagination-btn next d-none"
                  @click="setPage(neighborList.currentPage + 1)"
                  :disabled="neighborList.currentPage === totalPages"
                >
                  &gt;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import localStorage from "@/services/localStorage";
import axios from "axios";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueHighcharts from "vue2-highcharts";
import { mapGetters, mapActions } from "vuex";
// import Exporting from "highcharts/modules/exporting";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Dashboard | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    LineChartGenerator,
    VueHighcharts,
  },

  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    organizationId: localStorage.get("organizationId"),
    // organizationId: 1,
    // dateOptions: { day: "numeric", month: "long", year: "numeric" },
    dateOptions: { year: "numeric", month: "numeric", day: "numeric" },
    routerStatusList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    ipsecTransportStatusList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    value: {
      device_uptime: "0",
      nextRenewDate: "NA",
      usageToday: 0,
      total_audra: 0,
    },

    neighborList: {
      data: [],
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
      perPage: 5,
      currentPage: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: false,
    actionDelete: false,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {},
    is_loading: false,
    is_loading_ospf: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    statusLabel: [],
    ospfNeighborLastUpdate: "",
    connection: null,
    countConnectionCheck: 0,
    WANInfo: {
      status: "",
      proto: "",
      ip: "",
      subnetmask: "",
      gateway: "",
      dns: "",
      mac: "",
    },
    WANInfoArr: [],
    WANInfoType: "Primary",

    routerUsage: "",
    totalUsageSummary: "",

    totalUsageSummaryChartData: {
      labels: [],
      datasets: [
        {
          label: "",
          backgroundColor: "#ff9898",
          data: [],
        },
      ],
    },
    totalUsageSummaryChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "probability",
            },
          },
        ],
      },
      plugins: {
        title: {
          display: true,
          text: "Usage Graph (Last 7 days)",
          style: {
            fontFamily: "Inter",
            fontSize: "16px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        legend: {
          display: false,
        },
      },
    },

    routerUsageChartData: {
      labels: [],
      datasets: [
        {
          label: "Upload",
          backgroundColor: "#ff9898",
          fontFamily: "Inter",
          data: [],
          duration: [],
        },
        {
          label: "Download",
          data: [],
          duration: [],
        },
      ],
    },
    routerUsageChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: "Bandwidth Graph (Last 1 hour)",
          style: {
            fontFamily: "Inter",
            fontSize: "16px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
      },
    },

    routerUsageHighChartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Bandwidth Graph (Last 1 hour)",
        style: {
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      subtitle: {
        text: null,
      },
      xAxis: {
        // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        //   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        categories: [],
        title: {
          // text: "Time",
        },
      },
      yAxis: {
        title: {
          text: "Kbps",
          style: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        // labels: {
        //   formatter: function () {
        //     return this.value + '°';
        //   }
        // }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 4,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [],
    },

    totalUsageSummaryHighChartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Usage Graph (Last 7 days)",
        style: {
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        categories: [],
        style: {
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
        title: {
          text: "",
        },
      },
      yAxis: {
        title: {
          text: "GB",
          style: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        // labels: {
        //   formatter: function () {
        //     return this.value + '°';
        //   }
        // }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        style: {
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          lineColor: "#00a99c",
          marker: {
            radius: 4,
            lineColor: "#00a99c",
            fillColor: "#00a99c",
            lineWidth: 1,
          },
        },
      },
      series: [],
    },

    chartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Monthly Average Temperature",
      },
      subtitle: {
        text: "Source: WorldClimate.com",
      },
      xAxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yAxis: {
        title: {
          text: "Temperature",
        },
        labels: {
          formatter: function () {
            return this.value + "°";
          },
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 4,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [
        {
          name: "Tokyo",
          marker: {
            symbol: "square",
          },
          data: [
            7.0,
            6.9,
            9.5,
            14.5,
            18.2,
            21.5,
            25.2,
            {
              y: 26.5,
            },
            23.3,
            18.3,
            13.9,
            9.6,
          ],
        },
        {
          name: "Hongkong",
          marker: {
            symbol: "circle",
          },
          data: [
            2.0,
            4.9,
            5.5,
            14.5,
            10.2,
            11.5,
            25.2,
            {
              y: 27.5,
            },
            23.3,
            8.3,
            3.9,
            9.6,
          ],
        },
      ],
    },
  }),

  mounted() {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    const windowReload = localStorage.get("window_reload");
    if (windowReload) {
      localStorage.set("window_reload", false);
      window.location.reload();
    }
    this.api_url = "/dashboard";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    displayedNeighbors() {
      const startIndex = (this.neighborList.currentPage - 1) * this.neighborList.perPage;
      const endIndex = Math.min(
        startIndex + this.neighborList.perPage,
        this.neighborList.data.length
      );
      return this.neighborList.data.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.neighborList.data.length / this.neighborList.perPage);
    },
    formattedNextRenewDate() {
      if (!this.value.nextRenewDate || this.value.nextRenewDate == "NA") {
        return;
      }

      const date = new Date(this.value.nextRenewDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },

    isSubscriptionExpired() {
      if (!this.formattedNextRenewDate) return false;

      const today = new Date();
      const subscriptionDate = new Date(this.formattedNextRenewDate);

      // Only compare dates (not time)
      return subscriptionDate < new Date(today.toISOString().split("T")[0]);
    },
    formattedUptime() {
      if (
        typeof this.value.device_uptime === "string" &&
        this.value.device_uptime &&
        this.value.device_uptime !== "0"
      ) {
        this.value.device_uptime = this.value.device_uptime.trim();

        const uptimeStr = this.value.device_uptime.split("up")[1].trim();

        const daysMatch = uptimeStr.match(/(\d+)\s+days?/);
        const hoursMinutesMatch = uptimeStr.match(/(\d+):(\d+)/);
        const hoursOnlyMatch = uptimeStr.match(/(\d+)\s+hours?/);
        const minutesMatch = uptimeStr.match(/(\d+)\s+min/);

        const days = daysMatch ? parseInt(daysMatch[1]) : 0;
        const hours = hoursMinutesMatch
          ? parseInt(hoursMinutesMatch[1])
          : hoursOnlyMatch
          ? parseInt(hoursOnlyMatch[1])
          : 0;
        const minutes = hoursMinutesMatch
          ? parseInt(hoursMinutesMatch[2])
          : minutesMatch
          ? parseInt(minutesMatch[1])
          : 0;

        let formattedUptime = "";
        if (days > 0) {
          formattedUptime += `${days} day${days > 1 ? "s" : ""} `;
        }
        if (hours > 0) {
          formattedUptime += `${hours} hour${hours > 1 ? "s" : ""} `;
        }
        if (minutes > 0) {
          formattedUptime += `${minutes} min${minutes > 1 ? "s" : ""}`;
        }

        return formattedUptime.trim() || "0 mins";
      }
      return "0 mins";
    },
    formattedDowntime() {
      const serverGmtOffset = process.env.VUE_APP_SERVER_GMT_OFFSET || "+07:00";

      if (!this.value || !this.value.device_lastUpdateTime) {
        return "0 mins";
      }

      const lastUpdatedTime = new Date(
        this.value.device_lastUpdateTime.replace(" ", "T") + "Z"
      );

      const currentUtcTime = new Date();

      const offsetSign = serverGmtOffset.startsWith("-") ? -1 : 1;
      const [offsetHours, offsetMinutes] = serverGmtOffset
        .slice(1)
        .split(":")
        .map(Number);

      const offsetInMilliseconds =
        offsetSign * ((offsetHours * 60 + offsetMinutes) * 60 * 1000);
      const currentTimeInServerTz = new Date(
        currentUtcTime.getTime() + offsetInMilliseconds
      );
      const downtimeMs = currentTimeInServerTz - lastUpdatedTime;

      if (downtimeMs < 0) {
        return "0 mins";
      }

      const downtimeMinutes = Math.floor(downtimeMs / 60000);
      const downtimeDays = Math.floor(downtimeMinutes / 1440); // 1440 mins in a day
      const downtimeHours = Math.floor((downtimeMinutes % 1440) / 60);
      const downtimeRemainingMinutes = downtimeMinutes % 60;

      let formattedDowntime = "";
      if (downtimeDays > 0) {
        formattedDowntime += `${downtimeDays} days `;
      }
      if (downtimeHours > 0) {
        formattedDowntime += `${downtimeHours} hours `;
      }
      if (downtimeRemainingMinutes > 0) {
        formattedDowntime += `${downtimeRemainingMinutes} mins`;
      }

      return formattedDowntime.trim() || "0 mins";
    },
  },
  methods: {
    ...mapActions(["FETCH_PROFILE"]),
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },
    async initialize() {
      const _this = this;
      _this.FETCH_PROFILE();
      this.is_loading = true;
      this.is_loading_ospf = true;

      this.user_detail = this.profile;

      await this.getList()
        .then((response) => {
          _this.value = response.data;
          _this.routerStatusList = response.data.routerStatus;
          _this.routerStatusList.data = _this.routerStatusList.data
            ? _this.routerStatusList.data.slice(0, 5)
            : [];
          _this.ipsecTransportStatusList = response.data.ipsecTransportStatus;
          _this.setStatusLabel();
        })
        .catch((error) => {
          this.empty = true;
          console.log(error);
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
        });

      // await this.getOspfInfoFirstTime()
      //   .then((response) => {
      //     if (response.data != "NA") {
      //       _this.parseResponseOspf(response.data);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });

      await this.getRouterUsage()
        .then((response) => {
          this.routerUsage = response.data;
          this.setRouterUsageChartData();
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });

      await this.getTotalUsageSummary()
        .then((response) => {
          this.totalUsageSummary = response.data;

          // this.totalUsageSummaryChartData.datasets[0].data = this.totalUsageSummary.data;
          // this.totalUsageSummaryChartData.labels = this.totalUsageSummary.label;
          _this.setTotalUsageSummaryChart();
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error);
        });

      await this.getWANInfo()
        .then((response) => {
          _this.WANInfoArr = response.data.data;
          _this.setWANInfo("primary");
        })
        .catch((error) => {
          this.empty = true;
          console.log(error);
        });

      // let lineCharts = this.$refs.lineCharts;
      //   charts.showLoading('loading');

      // you also can use the delegateMethod()
      // lineCharts.delegateMethod("showLoading", "Loading...");
      // setTimeout(() => {
      // lineCharts.addSeries(_this.chartOptions);
      //   lineCharts.hideLoading();
      // }, 2000);

      this.is_loading = false;
      this.is_loading_ospf = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reloadRouterStatus: function () {
      this.getList()
        .then((response) => {
          this.routerStatusList = response.data.routerStatus;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    reloadIpsecTransportStatus: function () {
      this.getList()
        .then((response) => {
          this.ipsecTransportStatusList = response.data.ipsecTransportStatus;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = {};
        params = {
          ...this.filter,
          accountId: localStorage.get("accountId"),
          userId: localStorage.get("userId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            if (
              error.message == "Request failed with status code 429" ||
              error.message == "Unauthenticated."
            ) {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              reject(error);
            }
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    getWANInfo: function () {
      return new Promise((resolve, reject) => {
        let params = {};
        params = {
          userAccountId: localStorage.get("accountId"),
          accountId: localStorage.get("accountId"),
        };
        axios
          .get("/wan_status", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            if (error.message == "Unauthenticated.") {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              reject(error);
            }
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },

    changeIpSecTransportStatus(val, index) {
      const vpnLink = "/changeIpSecTunnelTransportStatus";

      const _this = this;

      this.statusLabel[index] = val.ipsec_is_active ? "Disconnecting.." : "Connecting..";
      this.$forceUpdate();
      const ipSecStatus = val.ipsec_is_active == 0 ? "connect" : "disconnect";
      axios({
        method: "POST",
        url: vpnLink,
        data: {
          accountId: val.accountId,
          profilename: val.ipsec_profile_name,
          status: ipSecStatus,
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (val.ipsec_is_active != 0) {
            setTimeout(() => {
              _this.disConnectTransport(val.id, val.ap_wi_mac, ipSecStatus, index);
            }, 5000);
          } else {
            let countConnectionCheck = 0;
            const connection = setInterval(function () {
              _this.checkConnectionStatus(
                val.id,
                val.ap_wi_mac,
                index,
                countConnectionCheck,
                connection
              );

              if (countConnectionCheck++ >= 30) {
                clearInterval(connection);
              }
            }, 1000);
          }

          // _this.$toaster.success(response.data.message)
        })
        .catch((errors) => {
          _this.statusLabel[index] = val.ipsec_is_active ? "Connected" : "Disconnected";
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message);
            _this.$setErrorsFromResponse(errors.response.data.errors);
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message);
            _this.$setErrorsFromResponse(errors.response.data);
          }
        })
        .finally(() => {
          // _this.is_loading = false
          this.$forceUpdate();
        });
    },

    disConnectTransport(id, ap_wi_mac, status, index) {
      const _this = this;
      axios({
        method: "post",
        url: "/updateIpsecTunnelTransportStatus",
        data: {
          id: id,
          ap_wi_mac: ap_wi_mac,
          status: status,
          accountId: localStorage.get("accountId"),
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function () {
          _this.ipsecTransportStatusList.data[index].ipsec_is_active = 0;
          _this.statusLabel[index] = "Disconnected";
        })
        .catch((errors) => {
          _this.statusLabel[index] = "Connected";
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          _this.$forceUpdate();
          _this.is_loading = false;
        });
    },

    checkConnectionStatus(id, ap_wi_mac, index, countConnectionCheck, connection) {
      let isConnected = 0;
      const _this = this;
      axios({
        method: "post",
        url: "/checkTunnelIpSecTransportStatus",
        data: {
          id: id,
          ap_wi_mac: ap_wi_mac,
          accountId: localStorage.get("accountId"),
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (response.data == "1") {
            isConnected = 1;
            clearInterval(connection);
          }
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          if (countConnectionCheck >= 30 || isConnected == 1) {
            if (isConnected == 1) {
              _this.ipsecTransportStatusList.data[index].ipsec_is_active = 1;
              _this.statusLabel[index] = "Connected";
            } else {
              _this.statusLabel[index] = "Disconnected";
            }
            _this.$forceUpdate();
          }
          _this.is_loading = false;
        });
    },

    getOspfInfoFirstTime() {
      const _this = this;
      _this.is_loading = true;
      return new Promise((resolve, reject) => {
        axios
          .post("/getOspfInfoFirstTime", {
            accountId: localStorage.get("accountId"),
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            if (error.message == "Unauthenticated.") {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              reject(error);
            }
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },

    getOspfNeighbor() {
      const _this = this;
      _this.is_loading_ospf = true;
      axios({
        method: "post",
        url: "/addChangeLog",
        data: {
          syncprocess: "routing_info_sync",
          command: "sh ip ospf neighbor json",
          accountId: localStorage.get("accountId"),
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (response.data.message == "OK") {
            let countConnectionCheck = 0;
            const connection = setInterval(function () {
              _this.loadOSPFRouteInfo(countConnectionCheck, connection);

              if (countConnectionCheck++ >= 30) {
                clearInterval(connection);
              }
            }, 1000);
          }
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          // _this.is_loading_ospf = false;
        });
    },

    loadOSPFRouteInfo(countConnectionCheck, connection) {
      let isfound;
      let routeInfo;
      const _this = this;

      axios({
        method: "post",
        url: "/loadRouteInfo",
        data: { accountId: localStorage.get("accountId") },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (response.data == "not ok" || !response.data) {
            isfound = 0;
          } else {
            routeInfo = response.data;
            isfound = 1;
          }
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          if (countConnectionCheck >= 30 || isfound == 1) {
            if (isfound == 1) {
              clearInterval(connection);
              _this.parseResponseOspf(JSON.parse(routeInfo));
            }
            this.$forceUpdate();
            _this.is_loading_ospf = false;
          }
        });
    },

    parseResponseOspf(routeInfo) {
      const _this = this;
      _this.neighborList.data = [];
      if (Object.keys(routeInfo).length) {
        this.ospfNeighborLastUpdate = "Updated : " + routeInfo.lastUpdate;
        let neighborObj = JSON.parse(routeInfo.data);
        neighborObj = neighborObj.neighbors;

        // console.log(neighborObj)

        if (neighborObj) {
          Object.keys(neighborObj).forEach(function (key) {
            neighborObj[key].forEach((element) => {
              _this.neighborList.data.push({
                key: key,
                address: element.address,
                state: element.state,
              });
            });
          });
        }
      }
    },

    setStatusLabel() {
      for (let i = 0; i < this.ipsecTransportStatusList.data.length; i++) {
        this.statusLabel[i] = !this.ipsecTransportStatusList.data[i].ipsec_is_active
          ? "Disconnected"
          : "Connected";
      }
    },

    setPage(pageNumber) {
      // Method to set current page
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.neighborList.currentPage = pageNumber;
      }
    },

    getRouterUsage() {
      return new Promise((resolve, reject) => {
        axios
          .get("/routerUsage/" + localStorage.get("accountId"))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    getTotalUsageSummary() {
      return new Promise((resolve, reject) => {
        axios
          .get("/totalusagesummary/" + localStorage.get("accountId"))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    setRouterUsageChartData() {
      let Gbflag = 0;
      let Mbflag = 0;
      const arrayLength = this.routerUsage.length;
      let download = 0;
      let upload = 0;
      const categories = [];
      const downloadData = {
        name: "Download",

        marker: {
          symbol: "circle",
        },
        data: [],
      };

      const uploadData = {
        name: "Upload",
        marker: {
          symbol: "circle",
        },
        data: [],
      };

      for (let i = 0; i < arrayLength; i++) {
        const item = this.routerUsage[i];
        download =
          item.timeinterval > 0 ? (item.download / item.timeinterval).toFixed(2) : 0;
        upload = item.timeinterval > 0 ? (item.upload / item.timeinterval).toFixed(2) : 0;
        if (isNaN(download) || !download) download = 0;
        if (isNaN(upload) || !upload) upload = 0;
        if (download > 1000) {
          if (parseInt(download / 1000) > 1000) Gbflag = 1;
          else Mbflag = 1;
        }

        if (upload > 1000) {
          if (parseInt(upload / 1000) > 1000) Gbflag = 1;
          else Mbflag = 1;
        }
      }

      for (let i = 0; i < arrayLength; i++) {
        const item = this.routerUsage[i];
        download =
          item.timeinterval > 0 ? (item.download / item.timeinterval).toFixed(2) : 0;
        upload = item.timeinterval > 0 ? (item.upload / item.timeinterval).toFixed(2) : 0;
        if (Gbflag == 1) {
          download = (download / 1000 / 1000).toFixed(2);
          upload = (upload / 1000 / 1000).toFixed(2);
        } else if (Mbflag == 1) {
          download = (download / 1000).toFixed(2);
          upload = (upload / 1000).toFixed(2);
        }

        if (isNaN(download) || !download) download = 0;
        if (isNaN(upload) || !upload) upload = 0;

        this.routerUsageChartData.labels.push(item.StartTime.slice(0, -3));
        this.routerUsageChartData.datasets[0].data.push(upload);
        this.routerUsageChartData.datasets[1].data.push(download);
        this.routerUsageChartData.datasets[0].duration.push(10);
        this.routerUsageChartData.datasets[1].duration.push(10);

        categories.push(item.StartTime.slice(0, -3));
        downloadData.data.push(parseInt(download));
        uploadData.data.push(parseInt(upload));
      }

      const lineCharts = this.$refs.lineCharts;
      // charts.showLoading('loading');
      // you also can use the delegateMethod()
      lineCharts.delegateMethod("showLoading", "Loading...");
      lineCharts.addSeries(downloadData);
      lineCharts.addSeries(uploadData);

      lineCharts.getChart().xAxis[0].setCategories(categories);
      if (Gbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Gbps" });
      } else if (Mbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Mbps" });
      } else {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Kbps" });
      }

      lineCharts.hideLoading();
    },

    setWANInfo(type) {
      if (!this.WANInfoArr.length) return;

      if (type == "primary") {
        this.WANInfoType = "Primary";
        this.WANInfo.status = this.WANInfoArr[0].pstatus;
        this.WANInfo.proto = this.WANInfoArr[0].pproto;
        this.WANInfo.ip = this.WANInfoArr[0].pip;
        this.WANInfo.subnetmask = this.WANInfoArr[0].psubnetmask;
        this.WANInfo.gateway = this.WANInfoArr[0].pgateway;
        this.WANInfo.dns = this.WANInfoArr[0].pdns;
        this.WANInfo.mac = this.WANInfoArr[0].pmac;
      } else {
        this.WANInfoType = "Secondary";
        this.WANInfo.status = this.WANInfoArr[0].sstatus;
        this.WANInfo.proto = this.WANInfoArr[0].sproto;
        this.WANInfo.ip = this.WANInfoArr[0].sip;
        this.WANInfo.subnetmask = this.WANInfoArr[0].ssubnetmask;
        this.WANInfo.gateway = this.WANInfoArr[0].sgateway;
        this.WANInfo.dns = this.WANInfoArr[0].sdns;
        this.WANInfo.mac = this.WANInfoArr[0].smac;
      }
    },

    setTotalUsageSummaryChart() {
      const totalData = {
        name: "Total",

        marker: {
          symbol: "circle",
        },
        data: this.totalUsageSummary.data.reverse(),
      };
      const lineCharts = this.$refs.totalUsageSummaryLineCharts;

      lineCharts.delegateMethod("showLoading", "Loading...");
      lineCharts.addSeries(totalData);

      lineCharts
        .getChart()
        .xAxis[0].setCategories(this.totalUsageSummary.label.reverse());

      lineCharts.hideLoading();
    },
  },
};
</script>

<style scoped>
.dashboard-card a h3 {
  font-size: 12px;
}
</style>
